import { render, staticRenderFns } from "./OrganizationStats.vue?vue&type=template&id=8ed3aefc&scoped=true&lang=pug&"
import script from "./OrganizationStats.vue?vue&type=script&lang=js&"
export * from "./OrganizationStats.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStats.vue?vue&type=style&index=0&id=8ed3aefc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed3aefc",
  null
  
)

export default component.exports